import React from 'react';
import commonStyles from '../AdminOrdersPage/AdminOrdersPage.module.scss';
import MediaLibraryModal from '../../components/common/MediaLibraryModal/MediaLibraryModal';

const AdminMediaPage = () => {
  // Chúng ta tái sử dụng MediaLibraryModal, 
  // nhưng cần chỉnh sửa nó một chút để nó hiển thị dạng "inline" (không phải popup)
  // Hoặc đơn giản nhất là mở Modal lên và không cho đóng.
  
  return (
    <div className={commonStyles.adminPage}>
      <h1>Quản Lý Thư Viện Ảnh</h1>
      <div style={{ height: '80vh', border: '1px solid #ddd', borderRadius: '8px' }}>
        <MediaLibraryModal 
          isOpen={true} 
          onClose={() => {}} 
          onFileSelect={() => {}} 
          isInline={true} 
        />
      </div>
    </div>
  );
};

export default AdminMediaPage;